import type React from 'react';
import { useCallback } from 'react';
import { mobileAppRedirectService } from '../../services/mobileAppRedirectService';
import type { MobilePlatform } from '../../utils/mobilePlatform';
import { useAppLaunchHint } from './hooks/useAppLaunchHint';
import { JoinActions } from './nested/JoinActions';
import { PageFooter } from './nested/PageFooter';
import { PageHeader } from './nested/PageHeader';
import { StoreLink } from './nested/StoreLink';

const TITLE_ID = 'mobile-app-redirect-title';

interface MobileAppRedirectPageProps {
  meetingId: string;
  platform: MobilePlatform;
  onJoinInBrowser: () => void;
}

export const MobileAppRedirectPage: React.FC<MobileAppRedirectPageProps> = ({
  meetingId,
  platform,
  onJoinInBrowser,
}) => {
  const { isHintVisible, watchAppLaunch } = useAppLaunchHint();

  const handleOpenApp = useCallback(() => {
    window.location.href = mobileAppRedirectService.buildAppLink({ meetingId, platform });

    // Android's `intent://` URL usually resolves itself, but embedded browsers
    // (a link opened from a messenger) may ignore the scheme outright and leave
    // the button doing nothing at all.
    watchAppLaunch();
  }, [meetingId, platform, watchAppLaunch]);

  return (
    <main className="mobile-app-redirect" aria-labelledby={TITLE_ID}>
      <div className="mobile-app-redirect__content">
        <PageHeader titleId={TITLE_ID} />

        <JoinActions
          isHintVisible={isHintVisible}
          onOpenApp={handleOpenApp}
          onJoinInBrowser={onJoinInBrowser}
        />

        <div className="mobile-app-redirect__divider">
          <span className="mobile-app-redirect__divider-label">or</span>
        </div>

        <StoreLink platform={platform} />
      </div>

      <PageFooter />
    </main>
  );
};
